export const fdefFormX = {
  formdefinition: [
    {
      control: "stepper",
      name: "schadensmeldung",
      label: "Schadenanzeige - Unbekannt",
      showSubformErrorCount: false,
      cols: "12",
      steps: [],
    },
  ],
  transformOut: [
    {
      fn: "setConst",
      target: "docx_template",
      value: "A_Dienstreisekasko",
    },
  ],
};
